export default "__VITE_ASSET__DFbev3Je__"